import { injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { TableRepo } from "../table.repo";
import { PaymentPointModel } from "@/core/models/payment-point.model";

interface _PaymentPointGetParams {
    search?: string;
    status?: string;
    waterFactoryId?: string;
    provinceId?: string;
    districtId?: string;
    wardId?: string;
}

@injectable()
export class PaymentPointRepo extends TableRepo<PaymentPointModel> {
    constructor() {
        super("/api/PaymentPoint");
    }

    async getData(index: number, params: _PaymentPointGetParams, pageSize = 10): Promise<ApiPage<PaymentPointModel>|null> {
        return await super.getData(index, params, pageSize);
    }

    async getAll(params: _PaymentPointGetParams = {}) {
        return await super.getAll(params);
    }

    async getPublic(waterFactoryId: string) {
        try {
            const response = await this.apiRepo.get<PaymentPointModel[]>(`${this.basepath}/public`, {waterFactoryId});
            if (response?.code === "00") {
                return response.result || [];
            }
            return [];
        } catch (err) {
            console.log(err);
            return [];
        }
    }

    async getNearest(latitude: number, longitude: number, waterFactoryId?: string) {
        try {
            const response = await this.apiRepo.get<PaymentPointModel>(`${this.basepath}/nearest`, {
                latitude,
                longtitude: longitude,
                waterFactoryId: waterFactoryId || ""
            });
            if (response?.code === "00") {
                return response.result;
            }
            return null;
        } catch (err) {
            console.log(err);
            return null;
        }
    }
}

